import { AutogenModelCalculateOtherCharge, AutogenRowCalculateOtherCharge } from "./autogen/AutogenModelCalculateOtherCharge";

export class ModelCalculateOtherCharge extends AutogenModelCalculateOtherCharge<RowCalculateOtherCharge> {
    constructor() {
        super(RowCalculateOtherCharge);
    }
}

export class RowCalculateOtherCharge extends AutogenRowCalculateOtherCharge {
}